import React from 'react';
import Multiselect from 'react-widgets/lib/Multiselect';
require('react-widgets/dist/css/react-widgets.css');

const renderMultiselect = ({ label, input, data, valueField,valueCheck, habilitar,textField, meta: {touched, error} }) =>(
    <div className="form-group">
       <label className="control-label">{label}</label>
     <Multiselect
      {...input} 
      onBlur={() => input.onBlur()} 
      value={input.value ||[]} 
      data={data}
      disabled={habilitar}
      valueField={valueField}
      textField={textField}
     />


        {touched && error && <span className="text-danger">{error}</span>}
    </div>  
);

export default renderMultiselect;




// WEBPACK FOOTER //
// ./src/container/renderMultiSelect.js